import { useSettingsState } from '~/atoms/SettingsState'

import { SettingToggle } from './SettingItems'
import { DefaultSettingsWrapper } from './Shared'

interface FaxSettingsProps {
  pbxId: number | undefined
}
export const FaxSettings = ({ pbxId }: FaxSettingsProps) => {
  const {
    settings: {
      fax: { includeCoverPage: isFaxCoverPageEnabled },
    },
    setFaxCoverPageEnabled,
  } = useSettingsState(pbxId)

  const handleFaxCoverPageToggle = () => {
    setFaxCoverPageEnabled(!isFaxCoverPageEnabled)
  }
  return (
    <DefaultSettingsWrapper>
      <SettingToggle
        label="Enable Fax Cover Page"
        isChecked={isFaxCoverPageEnabled}
        onClick={handleFaxCoverPageToggle}
      />
    </DefaultSettingsWrapper>
  )
}
